export default __webpack_public_path__ + "static/media/icon_notes_pressed..84cedc69.svg";